<template>
  <MovieGrid />
</template>


<script>
import MovieGrid from "@/components/MovieGrid.vue";

export default {
  name: "Playlist",
  components: {
    MovieGrid
  }
};
</script>
